module.exports = __webpack_public_path__ + "static/media/home-school-of-athens.206dade9.jpg";